// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__p-lav","name":"styles_name__2Q5np","phone":"styles_phone__2Zy8Q"};